$(document).ready(function () {

  // Custom product form activation
  if ($("#custom_product_widget").length) {

    $("#custom_activated").prop('checked', false);

    $("#custom_activated").on("change", function() {
      if($("#custom_activated").is(":checked")) {
        $("body").addClass("overflow-hidden");
        $("#custom_product_widget .custom_fields").fadeIn();
        $(".custom_product_field").prop('disabled', false).prop('required', true);
        $(".custom_fields input.field__input").trigger("keyup");
        $(".custom_fields select.select__select").trigger("change");
      } else {
        $("body").removeClass("overflow-hidden");
        $("#custom_product_widget .custom_fields").fadeOut();
        $(".custom_product_field").prop('disabled', true).prop('required', false);
      }
    });

    const maxChars = 11;

    $(".custom_product_field").on("keyup", function() {
        // Utilisation de `Array.from()` pour gérer les émojis comme des unités uniques
        const chars = Array.from($(this).val());
        if (chars.length > maxChars) {
            // Tronquer si le nombre de caractères dépasse la limite
            $(this).val(chars.slice(0, maxChars).join(""));
        }
    });

    // On détermine si le select est obligatoire fonction du champ texte correspondant
    $(".text_input").on("keyup", function() {
      $color_selector = $(this).parents("variant-selects").next("variant-selects").find(".color_select");
      $color_selector.prop("required", $(this).val() != "");
    });

    $("#add_custom_product").on("click", function() {
      // cleaner le formulaire
      $(".error").hide();
      $(".custom_fields .required").removeClass("required");

      // revalider les champs
      $(".color_select:required").each(function() {
        if ($(this).val() == "") {
          $(this).parents("variant-selects").addClass("required");
        }
      });

      // Après la validation, on envoie le formulaire s'il n'y a plus d'erreurs (class error ou required ici)
      if (!$(".custom_fields .required").length) {
        // remplace les émojis par leur date-code
        $('#text_1').next().val(replaceEmojis($('#text_1').val()));
        $('#text_2').next().val(replaceEmojis($('#text_2').val()));
        $('#text_3').next().val(replaceEmojis($('#text_3').val()));

        $("#custom_product_widget .custom_fields").fadeOut();
        $(".product-form__submit").click();
        $(".color_select, .field__input").val("");
      } else {
        $(".error").show();
      }
    });

    $(".icon-close").on("click", function() {
      $("body").removeClass("overflow-hidden");

      $("#custom_product_widget .custom_fields").fadeOut();
      $(".custom_fields .required").removeClass("required");
      $(".error").hide();
      $(".color_select, .field__input").val("");
      $("#custom_activated").prop("checked", false).trigger("change");
    });

/*     $(".custom_fields input.field__input").on("keyup", function() {
      var hidden_val = $(this).val();
      $('.icons span[data-value]').each(function(){
        var hidden_reg = new RegExp($(this).html(), "g");
        hidden_val = hidden_val.replace(hidden_reg, $(this).data("code"));
      });
      $(this).next().val(hidden_val);
    }); */

    let dernierInputFocus;

    $(".custom_product_field").on("focusin", function() {
        dernierInputFocus = $(this);
    });

    $(".icons span").on("click", function() {
      if (dernierInputFocus) {
        const emoji = $(this).html();
        const emoji_code = $(this).data("code");

        const currentChars = Array.from(dernierInputFocus.val());

        if (currentChars.length < maxChars) {
          // Ajouter l'émoji et mettre à jour la valeur de l'input
          dernierInputFocus.val(currentChars.join("") + emoji);

          // Re-vérifier la longueur après ajout
          const updatedChars = Array.from(dernierInputFocus.val());
          if (updatedChars.length > maxChars) {
              // Tronquer si la limite est dépassée après ajout
              dernierInputFocus.val(updatedChars.slice(0, maxChars).join(""));
          }

          // Mettre à jour la valeur de l'input caché associé
/*           var hidden_val = dernierInputFocus.val();
          $('.icons span[data-value]').each(function(){
            var hidden_reg = new RegExp($(this).html(), "g");
            hidden_val = hidden_val.replace(hidden_reg, $(this).data("code"));
          });
          dernierInputFocus.next().val(hidden_val); */
        }
      }
    });


    $(".custom_fields select.select__select").on("change", function() {
      var value = $(this).find("option:selected").val();
      $(this).next().val(value);
    });
  }

  // Megamenu au survol
  $(".header__inline-menu details").hover(function (e) {
    $(this).attr("open", true);
    $(this).find(".header__submenu").mouseleave(function (e) {
      $(this).parent().removeAttr("open");
    });
  }, function (e) {
    $(this).attr("open", false);
  });


  // Homepage Slideshow
  $(document).on('click', '.slideshow__slide, .image-with-text', function(){
    var redirect = $(this).find(".button").attr("href");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  // Section multicolonnes
  $(document).on('click', '.multicolumn-list__item', function(){
    var redirect = $(this).data("target");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  // Page collection
  $(document).on('click', '.card__media, .soldout_badge', function(){
    var redirect = $(this).parent(".card__inner").next(".card__content").find("a").attr("href");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  $(document).on('click', '.section-collection-list .card-wrapper', function(){
    var redirect = $(this).find("a").attr("href");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  $(document).on('click', '.section-images .column', function(){
    var redirect = $(this).find("a").attr("href");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  // au clic sur le p de class read_more, on ajoute la classe extend au div d'avant
  $(document).on('click', '.read_more', function(){
    $(this).prev().toggleClass("extend");
    $(this).find("span").toggleClass("hide");
    $(this).find("span").toggleClass("show");
  });

  // Switch layout
  // Gestionnaire de clic en jQuery
  $(document).on('click', '.layout_view span', function(event) {
    var layout = $(this).data("layout");
    switchView(layout);
  });

  // Fonction switchView en jQuery
  function switchView(layout) {
    var grid_classes_mobile = "grid--1-col-tablet-down grid--2-col-tablet-down";
    sessionStorage.setItem("layout", layout);
    if ($(window).width() < 990) {
      var grid_classes = grid_classes_mobile;
    }
    $('.layout_view span').removeClass("active");
    $('.layout_view span[data-layout="' + layout + '"]').addClass("active");
    $('#product-grid').removeClass(grid_classes).addClass(layout);
  }

  // Gallery
  if ($(".gallery_nav").length) {
    $(".gallery_nav a").click(function(){
      $("html, body").stop().animate({scrollTop: 0 }, 800);
    });

    if ($(window).width() > 479) {
      var galleryHeight = $(".product__info-wrapper").height();
      $(".elx-gallery slider-component").css("min-height", galleryHeight + "px");

      $(window).on("resize", function() {
        var galleryHeight = $(".product__info-wrapper").height();
        $(".elx-gallery slider-component").css("min-height", galleryHeight + "px");
      });
    }
  }

  // Page Panier
  // --------------------------------------------

  // Messages cadeaux
  if ($("#checkbox_message").length) {
    $(document).on('change', '#checkbox_message', function () {
      $('#gift_message_1').val('');
      $('#gift_message_2').val('');
      $('#gift_message_3').val('');
      $('#gift_message_4').val('');
      $('#gift_message_5').val('');

      if ($(this).is(":checked")) {
        $(".gift_message_fields").show();
      } else {
        $(".gift_message_fields").hide();
      }
    });
  }

  // Appeler la fonction pour mettre à jour la date de livraison estimée
  // Mise à jour de la date de livraison
  if ($(".js_shipping span").length) {
    calculerLivraisonEstimee();
  }
});

// Calculer la date de livraison estimée
// Cette fonction calcule la date de livraison estimée en fonction du jour actuel
// et de l'heure actuelle. Elle prend en compte les jours ouvrables et les week-ends.
// La date de livraison estimée est affichée dans un élément HTML avec la classe "shipping_date".
// La date est formatée au format "jour mois année" (ex: 15 septembre 2023).
function calculerLivraisonEstimee() {
  var maintenant = new Date();
  var joursOuvrables = 2;

  // Vérifier si aujourd'hui est un jeudi
  if (maintenant.getDay() == 4) { // Jeudi (dimanche=0, lundi=1, ..., samedi=6)
    // Vérifier l'heure actuelle
    if (maintenant.getHours() < 12) { // Avant midi
      joursOuvrables = 2;
    } else {
      joursOuvrables = 5;
    }
  }
  // Si aujourd'hui est vendredi, ajouter 5 jours ouvrables
  else if (maintenant.getDay() == 5) { // Vendredi
    joursOuvrables = 5;
  }
  // Si aujourd'hui est samedi, ajouter 4 jours ouvrables
  else if (maintenant.getDay() == 6) { // Samedi
    joursOuvrables = 4;
  }
  // Si aujourd'hui est dimanche, ajouter 3 jours ouvrables
  else if (maintenant.getDay() == 0) { // Dimanche
    joursOuvrables = 3;
  }

  // Ajouter le nombre de jours ouvrables pour estimer la date de livraison
  var dateLivraisonEstimee = new Date(maintenant.getTime() + joursOuvrables * 24 * 60 * 60 * 1000);
  var options = { year: 'numeric', month: 'long', day: 'numeric' };
  var dateFormatee = dateLivraisonEstimee.toLocaleDateString('fr-FR', options);

  // Mise à jour de l'élément HTML avec la classe "shipping_date"
  if (document.querySelector('.shipping_date')) {
    document.querySelector('.shipping_date').textContent = dateFormatee;
  }
}

function replaceEmojis(str) {
   $('.icons span[data-value]').each(function(){
      var hidden_reg = new RegExp($(this).html(), "g");
      str = str.replace(hidden_reg, $(this).data("code"));
   });
   return str;
}